// Generated by CoffeeScript 1.12.7
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('sp/ui/questions/question_forms/form',['require','underscore','../question_form'],function(require) {
  var Form, QuestionForm, _;
  _ = require('underscore');
  QuestionForm = require('../question_form');
  return Form = (function(superClass) {
    extend(Form, superClass);

    function Form() {
      return Form.__super__.constructor.apply(this, arguments);
    }

    Form.prototype.tagName = "ul";

    Form.prototype.initialize = function(options) {
      return Form.__super__.initialize.call(this, options);
    };

    Form.prototype.render = function() {
      Form.__super__.render.call(this);
      this.$el.attr({
        role: 'group',
        'aria-labelledby': "question-title-" + (this.model.get('_id'))
      });
      _.each(this.model.get('properties').labels, (function(_this) {
        return function(label, index) {
          var $input, $li, id;
          id = (_this.model.get("_id")) + "-" + index;
          $li = $("<li>");
          $("<label>").appendTo($li).attr({
            "for": id
          }).html(_.escape(label));
          $input = $("<input>").appendTo($li).attr({
            type: "text",
            name: id,
            id: id
          }).prop('required', _this.model.get('required') || false).change(function(e) {
            _this.getValues();
            return _this.trigger(QuestionForm.UPDATE_EVENT, _this);
          });
          return _this.$el.append($li);
        };
      })(this));
      if (this.model.get('properties').random) {
        this.randomize();
      }
      return this.el;
    };

    Form.prototype.setValues = function(vals) {
      if (vals == null) {
        vals = this.values;
      }
      if (_.isArray(vals) || vals.length) {
        return vals.forEach((function(_this) {
          return function(val, index) {
            var $input;
            return $input = _this.$el.find("label").filter(function() {
              return $(this).text() === val.label;
            }).siblings('input').first().val(val.value).trigger('change');
          };
        })(this));
      }
    };

    Form.prototype.getValues = function() {
      this.values = [];
      _.each(this.model.get('properties').labels, (function(_this) {
        return function(label, index) {
          var $input, id, value;
          id = (_this.model.get("_id")) + "-" + index;
          $input = _this.$el.find("input#" + id);
          value = $input.val();
          if (value && value.length) {
            return _this.values.push({
              label: label,
              value: value
            });
          }
        };
      })(this));
      if (_.isEmpty(this.values)) {
        this.values = null;
      }
      return this.values;
    };

    return Form;

  })(QuestionForm);
});

